import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GraceAccountsApi,
  GraceLinkage,
  MapGraceAccountRequest,
  MapGraceAccountResult,
} from '../tokens/grace-accounts.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `GraceAccountsApi`.
 *
 * Calls POST /services/embedded/api/master-admin/grace-accounts/map via HttpClient,
 * riding the signed-in master-admin bearer through the authInterceptor.
 * Rule 07 / Rule 10 — no mock fallback. Playwright tests intercept via `page.route()`.
 *
 * Authority required: ROLE_MASTER_ADMIN (enforced server-side and by roleGuard on the route).
 */
@Injectable({ providedIn: 'root' })
export class GraceAccountsService implements GraceAccountsApi {
  private readonly http = inject(HttpClient);

  map(req: MapGraceAccountRequest): Observable<MapGraceAccountResult> {
    return this.http.post<MapGraceAccountResult>(API_PATHS.GRACE_ACCOUNTS_MAP, req);
  }

  /** EM-1043 / K4 — GET the party's Grace linkage (read-only, master-admin only). */
  linkage(partyId: number): Observable<GraceLinkage> {
    return this.http.get<GraceLinkage>(API_PATHS.GRACE_ACCOUNTS_LINKAGE(partyId));
  }
}
